<template>
	<a 
		:href="url"
		target="_blank"
		class="fb-share-button"
	>
		<img 
			src="../../../assets/images/f_logo_RGB-Blue_72.png"
			class="w-100"
		>
	</a>
</template>

<script>
export default {
	data() {
    return {
      url: `http://www.facebook.com/share.php?u=${location.href}`
    };
  },
}
</script>

<style lang="scss" scoped>
.fb-share-button {
	width: 43.72px;
	height: 44px;
	display: block;
	&:hover {
		transform: rotate(23deg);
		* {
			opacity: 1;
		}
	}
}
</style>
